mutation DeleteTorahColumnOverlays($ids: [ID]!) {
  deleteTorahColumnOverlays(ids: $ids) {
    ok
    errors
    deletedCount
  }
}
